import styled from 'styled-components';
import { Box, Button } from '@bechtel/gds'
export const DocumentSectionStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.grey[100]};
`;
export const DocumentViewStyled = styled.div`
  height: 244px;
  width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacings[100]};
  & * canvas {
    margin: auto;
    width: 100% !important;
    height: 240px !important;
  }

  &:first-child {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const DocLoadingButtonContainerStyled= styled(Box).attrs({
  justifyContent: { sm: 'center'},
  alignItems: { sm: 'center' },
})`
height: 100%;
`

export const DocLoadingButtonStyled = styled(Button)`
width: auto;
`